import { useOutletContext } from "react-router-dom";

interface ContextType {
  setControlsComponent: (element?: React.ReactNode) => void;
}

export function useCounselingValues() {
  return useOutletContext<ContextType>();
}
